import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";

export class ManageFeeParams {
    page = 1;
    limit = LIMIT_PAGE_DEFAULT;
    createdByRowGuid?: string;
    fromDate?: number;
    toDate?: number;
}
